"use client";

import React from "react";
import { Phone, Mail, Printer, Clock, MapPin } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactMethods = [{
  title: "Call Us",
  content: "(743) 336-7302",
  subtext: "Direct Line",
  icon: Phone,
  link: "tel:3365550123"
}, {
  title: "Email Us",
  content: "hello@chippermulching.com",
  subtext: "General Inquiries",
  icon: Mail,
  link: "mailto:hello@chippermulching.com"
}, {
  title: "Business Hours",
  content: "Mon-Fri 7am-5pm",
  subtext: "Sat by appointment",
  icon: Clock
}, {
  title: "Service Area",
  content: "Burlington, NC",
  subtext: "Piedmont Triad region",
  icon: MapPin
}];
export default function ContactMethodsGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="253005" id="contact-information-section" className="w-full py-16 md:py-24 bg-gray-50 text-foreground">
      <div className="container mx-auto px-4 md:px-8">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {contactMethods.map((method, i) => <Card key={i} data-index={i} className="bg-white border-border/50 shadow-md hover:shadow-lg transition-shadow duration-300 h-full flex flex-col rounded-lg">
              <CardHeader className="pb-4 flex-none">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 text-primary">
                  <method.icon className="w-8 h-8" />
                </div>
                <CardTitle className="font-default text-xl md:text-2xl font-bold text-secondary">
                  {method.title}
                </CardTitle>
                <div className="w-4 h-[2px] bg-primary mt-3 rounded-lg" />
              </CardHeader>
              <CardContent className="flex-grow flex flex-col justify-start">
                {method.link ? <a href={method.link} className="font-default text-gray-700 text-lg font-medium hover:text-primary transition-colors">
                    {method.content}
                  </a> : <p className="font-default text-gray-700 text-lg font-medium">
                    {method.content}
                  </p>}
                {method.subtext && <p className="font-default text-muted-foreground text-sm mt-1">
                    {method.subtext}
                  </p>}
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}